@if (shouldShowControl()) {
  <div gkControlRow>
    <span gkControlLabel [showLabel]="controlConfig.showLabel">
      <gk-translated-label [configLabel]="controlConfig.label"></gk-translated-label>:</span>
      @if (getValue()) {
        <span gkControlValue [showLabel]="controlConfig.showLabel" [innerHTML]="getFormattedTemplate()"></span>
      }
    </div>
  }
